<template>
  <div id="home_header">
    <!-- 头部导航 -->
    <header class="header" :class="{ 'header-fixed' : headerFixed }">
    <div v-show="horizontal">
      <el-row style="    box-shadow: 0px 5px 2px -3px rgba(0, 0, 0, 0.24);">
          <el-col :span="5">
            <img src="../assets/logo.png" style="margin-top:6px;float:right;width:153px;" /> 
          </el-col>
          <el-col :span="14">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleMainSelect">
              <el-menu-item index="1" class="main-menu">首页</el-menu-item>
              <el-menu-item index="2" class="main-menu">产品服务</el-menu-item>
              <el-menu-item index="3" class="main-menu">合作案例</el-menu-item>
              <el-menu-item index="4" class="main-menu">新闻中心</el-menu-item>
              <el-menu-item index="5" class="main-menu">关于我们</el-menu-item>
            </el-menu>
          </el-col>
          <el-clo :span="5">
            <p>
            <a href="http://pms.zhonghuihaotai.com" style="text-decoration:none">
            <font style="border: 1px solid #3f9eff;color: #3f9eff;padding:5px 7px ;">
              中汇商联
            </font>
            </a>
            </p>
          </el-clo>
      </el-row>
    </div>
    <div v-show="vertical">
      <el-row>
          <el-col :span="12">
            <img src="../assets/logo.png" style="margin-top:6px;float:right;width:153px;" /> 
          </el-col>
          <el-col :span="12">
            <el-menu :default-active="activeIndex"  class="vertical-style"   mode="horizontal" @open="handleOpen" @close="handleClose" @select="handleMainSelect"  menu-trigger="false">
              <el-submenu index="1">
                <template slot="title" style="border-bottom-color:red!important"> <img src="../assets/menu.png" style="width:40px" @click="handlerClick"/> </template>
                <el-menu-item index="1">首页</el-menu-item>
                <el-menu-item index="2">产品服务</el-menu-item>
                <el-menu-item index="3">合作案例</el-menu-item>
                <el-menu-item index="4">新闻中心</el-menu-item>
                <el-menu-item index="5">关于我们</el-menu-item>
                <el-menu-item index="6">
                <p>
                <a href="#" style="text-decoration:none">
                <font style="border: 1px solid #3f9eff;color: #3f9eff;">
                  中汇商联
                </font>
                </a>
                </p>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
    </div>
    </header>
    <transition>
        <router-view></router-view>
    </transition>
     <div class="footer">
      <el-row>
        <el-col :span="5" >
          <div class="footer_one">
            <p><a href="http://www.zhonghuihaotai.com/#/website/about">关于我们</a></p>
            <p><a href="http://www.zhonghuihaotai.com/#/website/product_service">产品服务</a></p>
            <p><a href="http://www.zhonghuihaotai.com/#/website/news">新闻中心</a></p>
          </div>
        </el-col>
        <el-col :span="2">
          <div style="float: left;width: 1px;height: 100px;background: white;margin-top: 45px;margin-left: 50%;"></div>           
        </el-col>
        <el-col :span="12">
          <div class="footer_two">
            <p><img src="../assets/bot_icon_1.png" />&nbsp;北京市朝阳区东三环中路39号院建外SOHO西区2702~2706室</p>
            <p style="font-size: 16px;"><img src="../assets/bot_icon_2.png" />&nbsp;400-188-1656（分机号：616）</p>
            <div class="Trust_box">
              <p><img src="../assets/bot_icon.png" />&nbsp;zhht@zhonghuihaotai.com</p>
              <div class="Trust">
                <a href="https://xyt.xcc.cn/getpcInfo?sn=1721712962877468672&language=CN&certType=8&url=*.zhonghuihaotai.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
                <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
                <embed src="https://program.xinchacha.com/web/1721712962877468672=*.zhonghuihaotai.com.svg"width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a>
              </div>
            </div>
          </div>
        </el-col>
        <el-clo :span="5">
          <div class="footer_three">
            <div style="margin-right:20px">
              <p>中汇豪泰公众号</p>
              <p><img src="../assets/bot_bg.jpg" width="150px" /></p>
            </div>
            <div>
              <p>中福云购</p>
              <p><img src="../assets/zhongfu.png" width="150px" /></p>
            </div>
          </div>
          
        </el-clo>
      </el-row>
      <br style="clear:both;" />
    </div>
    <div class="copyright">
        <div style="padding-top: 45px; padding-bottom: 26px;font-size:12px">
          <p>Copyright @ 2017-2024 中汇豪泰 All rights reserved. <a style="text-decoration: auto;color:#888686;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备181001163号</a> <a style="text-decoration: auto;color:#888686;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602105090"> <img class="ba" src="https://img.zhonghuihaotai.com/file_20230825142458Au9cf.png"/>京公网安备 11010602105090号 </a>增值电信业务经营许可证京B2-20181016</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header',
  data () {
    return {
      bg_images: [require('../assets/bg_banner.jpeg')],
      cb_images: [require('../assets/logo_jt.png'),require('../assets/logo_jt.png'),require('../assets/logo_jt.png')],
      headerFixed:true,
      //banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],
      bannert:'/bg_banner.jpeg',
      height:"400px",
      cb_height:"400px",
      cb_carousel_height:"300px",
      horizontal:false,
      vertical:true,
      menuDisplay:'none',
      activeIndex:"1",
    }
  },
  methods: {
    onResize(){
      var width = document.documentElement.clientWidth;
      console.log(width);
      this.setCarouselHeight(width)
      this.setHeaderLayout(width)
    },
    setHeaderLayout(width){
      var cb_c_h = "340px";
      if (width <=1000) {
        this.vertical=true;
        this.horizontal=false;

      } else {
        this.horizontal=true;
        this.vertical=false;
      }

      if (width >= 1320) {
        this.cb_carousel_height="380px";
      } else if (width <1320) {
        this.cb_carousel_height="340px";
      }
    },
    setCarouselHeight(width){
      this.height = (width / 3.4).toString()+"px";
      this.cb_height = (width / 3).toString()+"px";
      // this.cb_carousel_height = (width /3)* (3/4).toString() + "px";
    },
    handleOpen(index, path){
      console.log(index, path)
    },

    handleClose(index, path){
      console.log(index, path)
    },
    handlerClick(){
      // console.log("wft")
    },
    handleMainSelect(val){
      var path = "";
      if (val == "1") {
        path = "/website/index";
      } else if (val == "2") {
        path = "/website/product_service";
      } else if (val == "3") {
        path = "/website/cooperation_case";
      } else if (val == "4") {
        path = "/website/news";
      } else if (val == "5") {
        path = "/website/about";
      }
      this.$router.push(path);
    }
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize);
    var path = this.$route.path;
    if (path == "/website/product_service" || path == "/website/product_service/" ) {
      this.activeIndex = "2";
    }
    console.log(path)
    if (path == "/website/cooperation_case" || path == "/website/cooperation_case/") {
      this.activeIndex = "3";
    }
    if (path == "/website/news" || path == "/website/news_detail") {
      this.activeIndex = "4";
    }
    if (path == "/website/about") {
      this.activeIndex = "5";
    }
    if (path == "/website/index") {
      this.activeIndex = "1";
    }
  }
}
</script>

<style scoped>
/* 头部导航 */
header{z-index: 1000;transition: all 0.5s ease;   background-color: #FFFFFF;  }
header.header-fixed{position: fixed;top: 0;left: 0;right: 0;}
header .el-menu-demo{padding-left: 200px!important;}
.carousel-img {
  width: 100%;
  height: 100%;
}
/*.main {
  margin-top: 60px;
}*/
/*.content-top p{
    text-align: center;
}
.content-cooper {
  background-color: #F4F5F6;
  margin-top: 40px;
  padding-bottom: 30px;
}
.content-cooper p{
  text-align: center;
}
*/


.title_img{
  text-align: center;
}

/*.content-top li {
  margin:7px;
 padding:5px;
 float:left;
 width:150px;
 height:190px;
 display: block;
 list-style:none;
}*/
#list {
 padding:0px;
 margin-left: 9%;
 margin-right: 2%;
 padding-top: 15px;
}
#list li{float:left;width:29%;height: auto;padding:6px;list-style:none;}
#list li .pic{display:block;width:auto;margin:0 auto;}
#list li .pic img{width:100%;height:100%;}

.footer {
  background-color: #252425;
  height: 200px;
  margin-top: 0px;
}
.footer p{
  color: white;
  font-size: 12px;
}
.footer_one {
  /*padding-top: 50px;*/
  float: right;
  padding-top: 43px
}
.footer_two{
  padding-top: 43px;
}
.footer_three{
  padding-top: 43px;
  display: flex;
}
.copyright {
  background-color: #212121;
  text-align: center;
}
.copyright p{
  color: #888686;
  margin-top: 0px;
}
.carousel-img { max-width: 100%;width: 100%;-ms-interpolation-mode: bicubic;}

.vertical-style {
    width: 80px;
    float: right;
    padding-right: 0px;
}
/*.vertical-style .el-menu{
  right: 0px;
}*/
/*.vertical-style li{
  text-align: left;
}*/
.el-icon-arrow-down {
  display: none!important;
}
.el-submenu__title {
  border-bottom: 0px!important;
}
@media screen and (max-width: 600px) {
  #list {
     padding:0px;
     margin-left: 2px;
     margin-right: 0px;
     padding-top: 15px;
    }
  #list li {
    display: inline;
    float: left;
    width: 29.9%;
  }
}

.cb_list ul{
    width: 50%;
    text-decoration: none;
    list-style-type: none;
    margin: 0;
    border: 0;
    padding: 0;
    font-style: normal;
    color: #323232;
    box-sizing: border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
}

.cb_list img {
  width:100%;
  height:100%;
}
.cb_list>li{
    float: left;
    width: 23%;
    text-align: center;
    /*border: 1px solid #ccc;*/
    /*height: 50%;*/
    /*padding-top: 10%;*/
    margin-left: 1%;
    margin-top: 1%;
    position: relative;
    list-style:none;
}
.cb_list>li>div{
    height: auto;
    /*position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #09BE07;*/
}
.cb_list>li>div>span{
    display: inline-block;
    margin-top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

/*.content-cb {
  background: url(../assets/bg_cb.png) no-repeat 0px -1px;
  min-height: 300px;
  background-color: #F4F5F6;
}
.content-cb p{
  text-align: center;
}


.content-cb img {
  max-width:100%;
}*/

@media screen and (min-width: 1400px) {
    .cb-carousel .el-carousel__container{
        height: 380px;
    }
}
@media screen and (min-width: 1349px) and (max-width: 1399px) {
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
}
@media screen and (max-width: 1348px) and (min-width: 1000px) {
/*  .cb-img-box {
      padding-top: 4%;
    }*/
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
}

@media screen and (max-width: 500px) and (min-width: 0px) {
    .content-cb {
      height: 250px
    }
    .cb-carousel .el-carousel__container{
        height: 170px;
    }
    .cb-img-box {
      padding-top: 4%;
    }
}

.el-menu--horizontal {
    border-right: none;
    border-bottom: solid 0px!important;
    }
.main-menu {
   font-size:18px!important;
   font-color:#666666!important;
   border-bottom:none!important;
}

.main-menu.is-active {
    font-color: #0e6eb8!important;
}
.footer a{
  text-decoration:none;
  color: white;
}
.el-menu-item.is-active,.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: none;
}
.el-menu-item.is-active,.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    border-bottom: none;
    color: #fff!important;
    background: #199ED8!important;
}
.el-menu--horizontal>.el-menu-item {
    /* border-bottom: 2px solid none !important; */
}
.ba{
    vertical-align: bottom;
    margin-left: 3px;
    margin-right: 2px;
    height: 17px;
}
/*@media screen and (max-width: 1000px) and (min-width: 801px) {
    .content-cb {
      height: 300px
    }
    .cb-carousel .el-carousel__container{
        height: 200px;
    }
    
}
*/
.Trust_box{
  display: flex;
}
.Trust{
  margin-left: 106px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue